import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/utils/apiClient';

export function useFeatureFlags({ enabled = true }: { enabled?: boolean } = {}) {
  const { data, isLoading, isError, error, refetch } = useQuery<Record<string, boolean>, Error>({
    queryKey: ['feature-flags'],
    enabled,
    queryFn: async () => {
      const { data: flags } = await apiClient.get<Record<string, boolean>>('/feature-flags');
      return flags;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: Infinity,
  });

  return {
    data: data ?? {},
    loading: isLoading,
    error: isError ? (error?.message ?? 'Failed to load feature flags') : null,
    refetch,
  };
}

export function useFeature(key: string): boolean {
  const { data } = useFeatureFlags();
  return Boolean(data[key]);
}
